'use client'
import { useState, useEffect, useCallback, useRef } from 'react'
import { SwiperSlide, SwiperRef } from 'swiper/react'
import clsx from 'clsx'

import CustomNavigation from '@/components/atoms/Slider/CustomNavigation'
import customPaginationStyles from '@/components/atoms/Slider/CustomPagination.module.scss'
import Slider from '@/components/atoms/Slider'

import ShareItem from '@/components/atoms/Share'
import { ShareItemProps } from '@/components/atoms/Share/Share.types'
import styles from './ShareSlider.module.scss'

const ShareSlider = ({ items }: { items: ShareItemProps[] }) => {
  const [shareLink, setShareLink] = useState('')
  const sliderRef = useRef<SwiperRef>(null)

  const handlePrev = useCallback(() => {
    if (!sliderRef.current?.swiper) return
    sliderRef.current.swiper.slidePrev()
  }, [])

  const handleNext = useCallback(() => {
    if (!sliderRef.current?.swiper) return
    sliderRef.current.swiper.slideNext()
  }, [])

  const pagination = {
    clickable: true,
    renderBullet: function (_: number, className: string) {
      return '<span class="' + clsx(className) + '"></span>'
    },
  }

  useEffect(() => {
    const link = window.location.href
    setShareLink(link)
  }, [])

  return (
    <div
      className={clsx(styles.shareSlider, customPaginationStyles.pagination)}
    >
      <Slider
        ref={sliderRef}
        totalSlides={items.length}
        spaceBetween={6}
        slidesPerView={'auto'}
        pagination={pagination}
        config={{
          withPagination: true,
        }}
      >
        {items.map((item) => (
          <SwiperSlide key={item.id}>
            <ShareItem
              {...item}
              value={shareLink}
            />
          </SwiperSlide>
        ))}
        <CustomNavigation
          handlePrev={handlePrev}
          handleNext={handleNext}
        />
      </Slider>
    </div>
  )
}

export default ShareSlider
